import createEditManageWorkOrderType from '../modals/createEditManageWorkOrderType/lan/es';
import deleteManageWorkOrderType from '../modals/deleteManageWorkOrderType/lan/es';

export default {
    manage_workOrderType_name: "Nombre",
    manage_workOrderType_form: "Formulario",
    manage_workOrderType_estimatedDuration: "Duración estimada",
    manage_workOrderType_description: "Descripción",
    ...createEditManageWorkOrderType,
    ...deleteManageWorkOrderType,
}